function ArrowSvg ({className = 'default'}) {
    return(
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
            <path d="M11 6L6 1L1 6" stroke="#0E0F0F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
};

export default ArrowSvg;